import { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router'
import { gql, useQuery } from '@apollo/client'
import { Sidebar } from '@/components/layout/ops/Sidebar'
import { OpsTopbar } from '@/components/layout/ops/OpsTopbar'
import { setUserDirectory } from '@/data/admin/users'

const STORAGE_KEY = 'xlops.sidebar.collapsed'

// Tenant user directory (id -> name), available to any authenticated role. Loaded once
// here (OpsLayout is mounted for every signed-in user) so all modules can resolve user
// ids to names via userById() instead of showing raw UUIDs.
const GET_USERS_DIRECTORY = gql`
  query UsersDirectory {
    usersDirectory {
      id
      displayName
      email
    }
  }
`

export default function OpsLayout() {
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.localStorage.getItem(STORAGE_KEY) === '1'
  })

  const { data: usersData } = useQuery(GET_USERS_DIRECTORY, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  })
  useEffect(() => {
    if (usersData?.usersDirectory) setUserDirectory(usersData.usersDirectory)
  }, [usersData])

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0')
  }, [collapsed])

  return (
    <div className="min-h-screen">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      <div
        className="transition-[margin] duration-200 ease-in-out"
        style={{ marginLeft: collapsed ? 72 : 248 }}
      >
        <OpsTopbar />
        <main>
          <div className="max-w-[1320px] mx-auto px-8 py-8 pb-20">
            <Suspense
              fallback={
                <div className="flex items-center justify-center py-20">
                  <div className="text-sm text-muted-foreground">Loading…</div>
                </div>
              }
            >
              <Outlet />
            </Suspense>
          </div>
        </main>
      </div>
    </div>
  )
}
